import React, { useEffect, useState } from 'react';
import SurveyResponsesCount from './SurveyResponsesCount';
import OpenResponsesTable from './OpenResponsesTable';
import { getQuestionOptionStats } from 'services/reports';
import { Spinner, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SurveyResponses = ({ surveyId }) => {
  const [optionStats, setOptionStats] = useState(null);
  const [openStats, setOpenStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setOptionStats(null);
    setOpenStats(null);
    setError('');

    getQuestionOptionStats(surveyId)
      .then(data => {
        if (!isMounted) return;
        if (data && data.option_stats) {
          setOptionStats(data.option_stats);
          setOpenStats(data.open_stats || {});
        } else {
          setOptionStats({});
          setOpenStats({});
          setError('No hay datos disponibles para esta encuesta.');
        }
      })
      .catch(() => {
        if (!isMounted) return;
        setOptionStats({});
        setOpenStats({});
        setError('Error al obtener los datos de la encuesta.');
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [surveyId]);

  if (loading) {
    return (
      <div className="text-center my-4">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="text-center my-4">
        {error}
      </Alert>
    );
  }

  if (!optionStats && !openStats) return null;

  return (
    <>
      <SurveyResponsesCount option_stats={optionStats} />

      <OpenResponsesTable open_stats={openStats} />
    </>
  );
};

SurveyResponses.propTypes = {
  surveyId: PropTypes.number.isRequired
};

export default SurveyResponses;
